const v4348 = Object.prototype.toString;
export function b(p4891) {
  switch (v4348.call(p4891)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return true;
    default:
      return d(p4891, Error);
  }
}
function f687(p4892, p4893) {
  return "[object " + p4893 + "]" === v4348.call(p4892);
}
function f688(p4894) {
  return f687(p4894, "ErrorEvent");
}
function f689(p4895) {
  return f687(p4895, "DOMError");
}
function f690(p4896) {
  return f687(p4896, "DOMException");
}
export function i(p4897) {
  return f687(p4897, "String");
}
export function g(p4898) {
  return p4898 === null || typeof p4898 != "object" && typeof p4898 != "function";
}
export function f(p4899) {
  return f687(p4899, "Object");
}
export function c(p4900) {
  return typeof Event != "undefined" && d(p4900, Event);
}
export function a(p4901) {
  return typeof Element != "undefined" && d(p4901, Element);
}
export function h(p4902) {
  return f687(p4902, "RegExp");
}
function f697(p4903) {
  return !!p4903 && !!p4903.then && typeof p4903.then == "function";
}
export function j(p4904) {
  return f(p4904) && "nativeEvent" in p4904 && "preventDefault" in p4904 && "stopPropagation" in p4904;
}
export function e(p4905) {
  return typeof p4905 == "number" && p4905 !== p4905;
}
export function d(p4906, p4907) {
  try {
    return p4906 instanceof p4907;
  } catch (e37) {
    return false;
  }
}